module.exports = __webpack_public_path__ + "static/media/sponsor.17e8eed6.jpg";